// extracted by mini-css-extract-plugin
export default {"footer":"xb6lf3N6","mobile":"mobile","desktop":"desktop","menu":"d1nxb8DZ","menuItem":"mKqhUbIQ","link":"SgmAsYYz","logo":"JXG132G1"};